import React from "react";

const BillingPatientDetails = ({
  patientData,
  informationData,
}: {
  patientData: any;
  informationData: any;
}) => {
  const textStyle = {
    fontWeight: "bold",
    fontSize: "16px",
    textAlign: "center",
    width: "100%",
    borderTop: "1px solid #c7c5c5",
    borderBottom: "1px solid #c7c5c5",
    paddingTop: "3px",
  };
  const containerStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    marginTop: "4px",
    fontSize: "12px",
  };
  const rowStyle = {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
  };
  const labelStyle = {
    width: "76px",
    whiteSpace: "nowrap",
    fontSize: "10px",
  };
  const valueStyle = {
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const labelFirstStyle = {
    width: "116px",
    marginLeft: "45px",
    whiteSpace: "nowrap",
    fontSize: "10px",
  };

  return (
    <>
      <div style={textStyle}>
        <span>OPD PAYMENT RECEIPT</span>
      </div>
      {patientData?.referralDoctorName && (
        <div style={{ borderBottom: "1px solid #c7c5c5" }}>
          <span style={{ fontSize: "14px" }}>Bill To</span>
          <span style={{ fontWeight: "bold", fontSize: "14px" }}>
            : {patientData?.referralDoctorName}
          </span>
        </div>
      )}
      <div style={containerStyle}>
        <div style={rowStyle}>
          <span style={labelStyle}>RECEIPT # </span>
          <span style={valueStyle}>: {patientData?.billingNumber || ""}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelFirstStyle}>DATE </span>
          <span style={valueStyle}>
            :{" "}
            {patientData?.billingDate
              ? new Date(patientData.billingDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>NAME </span>
          <span style={valueStyle}>: {patientData?.patientName || ""}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelFirstStyle}>OPD CASE # </span>
          <span style={valueStyle}>: {patientData?.opdCaseNumber || ""}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>GENDER / AGE </span>
          <span style={valueStyle}>
            : {patientData?.gender}
            {patientData?.ageYear > 0 ||
              patientData?.ageMonth > 0 ||
              patientData?.ageDay > 0
              ? " / "
              : ""}
            {patientData?.ageYear > 0
              ? patientData?.ageYear?.toString() + "Y"
              : ""}{" "}
            {patientData?.ageMonth > 0
              ? patientData?.ageMonth?.toString() + "M"
              : ""}{" "}
            {patientData?.ageDay > 0
              ? patientData?.ageDay?.toString() + "D"
              : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span style={labelFirstStyle}>DOCTOR </span>
          <span style={valueStyle}>
            : {patientData?.doctorIdLabel ? patientData?.doctorIdLabel : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>ADDRESS </span>
          <span style={valueStyle}>
            : {patientData?.fullAddress ? patientData?.fullAddress : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span style={labelFirstStyle}>DEPARTMENT </span>
          <span style={valueStyle}>
            :{" "}
            {patientData?.departmentIdLabel
              ? patientData?.departmentIdLabel
              : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>EMR # </span>
          <span style={valueStyle}>: {patientData?.patientId || ""}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelFirstStyle}>REG NO </span>
          <span style={valueStyle}>
            : {informationData?.registrationNumber || ""}
          </span>
        </div>
      </div>
    </>
  );
};

export default BillingPatientDetails;
